import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaFutbol, FaClock } from 'react-icons/fa';
import { useLanguage } from '../contexts/LanguageContext';
import Header from './Header';
import Footer from './Footer';
import './ComingSoon.css';

const ComingSoon: React.FC = () => {
  const { t } = useLanguage();

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="coming-soon">
      <Header />
      <section className="coming-soon__hero">
        <motion.div
          className="coming-soon__hero-content"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.6, -0.05, 0.01, 0.99] }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <FaFutbol className="coming-soon__hero-icon" />
          </motion.div>
          <motion.h1
            className="coming-soon__title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            {t('comingSoon.title')}
          </motion.h1>
          <motion.p
            className="coming-soon__subtitle"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            {t('comingSoon.subtitle')}
          </motion.p>
          <motion.div
            className="coming-soon__icon-wrapper"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            <FaClock className="coming-soon__clock-icon" />
          </motion.div>
        </motion.div>
      </section>
      <Footer />
    </div>
  );
};

export default ComingSoon;

